import { WAKE_UP_DEVICE } from '@/services/api/onlineCommand'

export default {
  props: {
    imei: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      intervalCounter: null,
      seconds: 60,

      loop: 1,
    }
  },
  mounted() {
    this.sendOnlineCommandWakeup()
    this.intervalCounter = setInterval(async () => {
      if (this.seconds <= 0 && this.loop >= 2) {
        this.$emit('countdownEnd')
      } else if (this.seconds <= 0) {
        this.loop++
        this.seconds = 60
        this.sendOnlineCommandWakeup()
      } else {
        this.seconds--
      }
      await this.$nextTick()
      if (this.seconds === 15 || this.seconds === 30 || this.seconds === 45) {
        this.$emit('sendCommandStream')
      }
    }, 1000)
  },
  beforeDestroy() {
    if (this.intervalCounter) {
      clearInterval(this.intervalCounter)
    }
  },
  methods: {
    sendOnlineCommandWakeup() {
      const imei = this.imei
      this.$apollo.mutate({
        mutation: WAKE_UP_DEVICE,
        variables: {
          input: {
            imei,
          },
        },
      })
    },
  },
}
